export const PERIOD = {
  LAST_SEVEN_DAYS: { value: 1, text: { ja: "過去7日間", en: "Last 7 days" } },
  LAST_THIRTY_DAYS: { value: 2, text: { ja: "過去30日間", en: "Last 30 days" } },
  LAST_THREE_MONTHS: { value: 3, text: { ja: "過去3ヶ月", en: "Last 3 Months" } },
  LAST_MONTH: { value: 4, text: { ja: "先月", en: "Last Month" } },
  THIS_MONTH: { value: 5, text: { ja: "今月", en: "This Month" } },
  PERIOD_SPECIFICATION: { value: 6, text: { ja: "日付指定", en: "Fixed date" } },
} as const;

export const REPORT_TYPE = {
  PREBID_ANALYTICS: { value: 1, text: "Prebid Analytics" },
  BI_REPORT: { value: 2, text: "BI Report" },
  GOOGLE_AD_MANAGER: { value: 3, text: "Google Ad Manager" },
  CWV_REPORT: { value: 4, text: "CWV Report" },
} as const;

export const CURRENCY = {
  JPY: { text: "JPY", sign: "¥", language: "ja" },
  TWD: { text: "TWD", sign: "NT$", language: "zh-TW" },
} as const;
